'use client'
import type { FC, ReactElement } from 'react'
import type { MenuButtonProps, MenuProps } from '@chakra-ui/react'
import { Box, Flex, HStack, Menu, MenuButton } from '@chakra-ui/react'
import { CounterBadge, GrandText } from 'ui'
import { BiChevronDown } from 'react-icons/bi'
import { createCn } from 'shared-utils'
import { clsx } from 'clsx'
import { filterButtonProps } from './filterButtonProps'

interface IFilterMenusProps extends Partial<MenuProps> {
  filterName: string
  list: ReactElement
  menuButtonProps?: Partial<MenuButtonProps>
  counter?: number
}

const cn = createCn('filter-menus')

export const FilterMenus: FC<IFilterMenusProps> = ({
  filterName,
  list,
  menuButtonProps: { className, ...menuButtonProps } = {},
  counter,
  ...props
}) => {
  return (
    <Menu {...props}>
      <MenuButton
        as={Box}
        className={clsx(cn(), className)}
        {...filterButtonProps}
        {...menuButtonProps}
      >
        <HStack align="center" gap={1}>
          <GrandText fontSize="sm">{filterName}</GrandText>
          {counter && counter > 0 && (
            <Box>
              <CounterBadge isAnimated={false} value={counter} boxShadow="none" />
            </Box>
          )}
          <Flex align="center">
            <BiChevronDown />
          </Flex>
        </HStack>
      </MenuButton>

      {list}
    </Menu>
  )
}
